import { render, staticRenderFns } from "./mapAlign.vue?vue&type=template&id=561960bd&scoped=true"
import script from "./mapAlign.vue?vue&type=script&lang=js"
export * from "./mapAlign.vue?vue&type=script&lang=js"
import style0 from "./mapAlign.vue?vue&type=style&index=0&id=561960bd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "561960bd",
  null
  
)

export default component.exports